export const breakpoints = {
    'mobile': 0,
    'desktop': 1230
}
